module.exports = __webpack_public_path__ + "img/haefele_logo_1.819eaad8.svg";